import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

// Auth Users
// import Dashboard from "../../views/Dashboard/Dashboard";
import AccountManagement from "../../views/AccountManagement/AccountManagement";
import PageNotFound from "../../views/Errors/404Error";
import Plans from "../../views/Plans/Plans";
import CustomPlanPage from "../../views/Plans/CustomPlan";
// import Login from "../../views/Login/Login";
// import Signup from "../../views/Signup/Signup";
import Tutorial from "../../views/Tutorial/Tutorial";

export class NewUserRoutes extends Component {
  render() {
    return (
      <Switch>
        //! ACTIVE ROUTES //! LIVE ROUTES
        <Route exact path="/tutorial" component={Tutorial} />
        <Route exact path="/" component={Plans} />
        <Route exact path="/plans" component={Plans} />
        <Route exact path="/accountManagement" component={AccountManagement} />
        //! CUSTOM PLAN ROUTES
        {/* <Route exact path="/customplan/awt2ojqdt" component={CustomPlan} /> */}
        {/* <Route exact path="/customplan/egdtc94mt" component={CustomPlan} /> */}
        {/* <Route exact path="/customplan/jtd03hfbe" component={CustomPlan} />  2-year Annual plan*/}
        {/* 1-year Monthly Plan */}
        {/* <Route exact path="/customplan/eg1tey9q" component={CustomPlan} /> */}
        {/* <Route exact path="/customplan/jt7ds34s" component={CustomPlan} /> */}
        {/* <Route exact path="/customplan/dj73q9e6" component={CustomPlan} /> */}
        {/* <Route exact path="/customplan/hd76hy4w" component={CustomPlan} /> */}
        <Route exact path="/customplan/hqa2ty3" component={CustomPlanPage} />
        {/*  */}
        //! FOR TESTING (COMMENT OUT WHEN PUSHING TO LIVE)
        {/*  */}
        //! INACTIVE ROUTES
        {/* <Route exact path="/test" component={Test} /> */}
        {/* <Route exact path="/dashboard" component={Dashboard} /> */}
        {/* <Route exact path="/" component={Dashboard} /> */}
        {/* <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} /> */}
        {/* <Route exact path="/GroupSharing" component={GroupShare} />
        <Route exact path="/audittrailmapview" component={SimpleMap} />
        <Route exact path="/chatbot" component={Chatbot} /> */}
        {/*  */}
        //!DO NOT COMMENT OUT - MUST BE LAST
        <Route component={PageNotFound} />
      </Switch>
    );
  }
}

export default NewUserRoutes;
